import { useCallback } from 'react';
import { useLocation, useSearchParams } from 'react-router';
import { useCobrandedPath } from 'features/cobrand/hooks/useCobrandUtils';
import { isValidUUID } from 'utils';
import { SURVEY_EVENT_ID_QUERY_PARAM, TENANT_ID_QUERY_PARAM } from '../constants';

export const useAssessmentsPaths = () => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const tenantId = searchParams.get(TENANT_ID_QUERY_PARAM);
  const surveyEventId = searchParams.get(SURVEY_EVENT_ID_QUERY_PARAM);
  const isValidPath = pathname === '/assessments' || pathname === '/assessments/verify';

  const assessementsVerifyPath = useCobrandedPath('/assessments/verify');
  const assessmentsPath = useCobrandedPath('/assessments');

  const appendAssessmentsQueryParams = useCallback(
    (path: string): string => {
      const params = new URLSearchParams();
      if (tenantId) params.set(TENANT_ID_QUERY_PARAM, tenantId);
      if (surveyEventId) params.set(SURVEY_EVENT_ID_QUERY_PARAM, surveyEventId);

      const queryString = params.toString();
      if (!queryString) return path;

      return `${path}?${queryString}`;
    },
    [surveyEventId, tenantId],
  );

  const assessementsVerifyPage = appendAssessmentsQueryParams(assessementsVerifyPath);
  const assessmentsPage = appendAssessmentsQueryParams(assessmentsPath);

  return {
    isValidPath,
    hasValidParams: isValidUUID(surveyEventId) && !!tenantId?.trim(),
    assessementsVerifyPage,
    assessmentsPage,
    tenantId,
    surveyEventId,
  };
};
